  export const setMemberBodyMeasurements = (value) => {
    return {
      type: "SET_MEMBER_BODY_MEASUREMENTS",
      payload: { data: value },
    };
  };
  export const setMemberBodyMeasurementsCount = (value) => {
    return {
      type: "SET_MEMBER_BODY_MEASUREMENTS_COUNT",
      payload: { data: value },
    };
  };
  export const addBodyMeasurementsModalAction = (value) => {
  return {
    type: "ADD_BODY_MEASUREMENTS_MODAL",
    payload: { data: value },
  };
};